import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/productWechat',
    name: 'ProductWechat',
    component: () => import('../views/ProductWechat.vue')
  },
  {
    path: '/downloadApp',
    name: 'DownloadApp',
    component: () => import('../views/DownloadApp.vue')
  },
  {
    path: '/aboutUs',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

export default router
